var functionMap = {
    'add-user': validateUserAdd,
    'reset-pass': validatePasswords,
    'new-device': validateNewDevice,
    'new-scene': validateNewScene
};

exports.validateItem = function (model, item, callback) {
    var execFunction = functionMap[model];
    var result = execFunction(item);
    callback(result);
}


/////////////////////////// VALIDATOR OBJECTS //////////////////////
function validateUserAdd(item) {
    var validators = [
        {'data': {object:item, exclude:{'name': true}}, 'validate': allFieldsFilled, 'name': 'User'},
        {'data': item['email'], 'validate': isValidEmail, 'name': 'Email'},
        {'data': item['role'], 'validate': isValidRole, 'name': 'Role'},
        {'data': item['password'], 'validate': isValidPassword, 'name': 'Password'},
    ];
    return executeValidators(validators);
}

function validatePasswords(item) {
    var validators = [
        {'data': {object:item, exclude:{}}, 'validate': allFieldsFilled, 'name': 'Password'},
        {'data': item['new'], 'validate': isValidPassword, 'name': 'Password'},
        {'data': item['new2'], 'validate': isValidPassword, 'name': 'Password'},
        {'data': [item['new'], item['new2']], 'validate': isSame, 'name': 'Passwords'},
    ];
    return executeValidators(validators);
}

function validateNewDevice(item){
    var validators = [
        {'data': {object:item, exclude:{}}, 'validate': allFieldsFilled, 'name': 'Device'},
        {'data': item['ip'], 'validate': isValidWebAddress, 'name': 'IP'},
        {'data': item['fields'], 'validate': isValidArray, 'name': 'Fields'},
        {'data': item['scenes'], 'validate': isValidArray, 'name': 'Scenes'},
        {'data': item['functions'], 'validate': isValidArray, 'name': 'Functions'}
    ];
    return executeValidators(validators);
}

function validateNewScene(item){
    var validators = [
        {'data': {object:item, exclude:{}}, 'validate': allFieldsFilled, 'name': 'Scene'},
        {'data': item['percentage'], 'validate': isValidPercentage, 'name': 'Percentage'}
    ];
    return executeValidators(validators);
}
/////////////////////////// VALIDATOR LOOP //////////////////////

function executeValidators(validators) {
    var result;
    for (var i = 0; i < validators.length; i++) {
        result = validators[i].validate(validators[i].data)
        if (result['action'] === __('Fail')) {
            var detailField = validators[i]['name'] ? validators[i]['name'] + ' ' : '';
            result['msg'] = detailField + result['msg'];
            break;
        }
    }
    return result;
}

/////////////////////////// VALIDATOR FUNCTIONS //////////////////////

function allFieldsFilled(validateData) {
    var object = validateData['object'];
    var exclude = validateData['exclude'];

    for (var property in object) {
        if (object.hasOwnProperty(property)) {
            if (!exclude[property] && (object[property] === '' || object[property] === undefined || object[property] === null)) {
                return {'action':__('Fail'), 'msg': property + __('Validator.Mandatory')};
            }
        }
    }
    return {'action':__('Success'), 'msg':'all filled'};
}

function isValidEmail(email) {
    if (!email) return {'action':__('Success'), 'msg':'is valid email'};
    if (email.match(/(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/)) {
        return {'action':__('Success'), 'msg':__('Validator.Success', 'email')};
    }
    return {'action':__('Fail'), 'msg':__('Validator.Fail', 'email')};
}

function isValidRole(role) {
    if(role > 3 || role < 0){
        return {'action':__('Fail'), 'msg':__('Validator.Success', 'role')};
    } else {
        return {'action':__('Success'), 'msg':__('Validator.Fail', 'role')};
    }
}

function isValidPassword(str) {
    if (str.match(/[a-z]+/) 
        && str.match(/[A-Z]+/) 
        && str.match(/[0-9]+/) 
        && str.length >= 6) {
        return {'action':__('Success'), 'msg':__('OK')};
    }
    return {'action':__('Fail'), 'msg':__('Validator.ValidPassword')};
}

//Checks if all elements are the same as the first. Ideal for checking two elements
function isSame(arr) {
  var item1 = arr[0];
  for(var i = 1; i < arr.length; i++){
    if(arr[i] !== item1){
      return {'action':__('Fail'), 'msg':__('Validator.MatchPassword')};
    }
  }
  return {'action':__('Success'), 'msg':__('OK')};
}

function isValidArray(arr){
    var isArr = Array.isArray(arr);
    if(!isArr){
        return {'action':__('Fail'), 'msg':__('Validator.Array')};
    }
    return {'action':__('Success'), 'msg':__('OK')};
}

function isValidWebAddress(addr){
    var isIp = addr.match(/\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/g);
    var isUrl = addr.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    
    if(!isIp && !isUrl){
        return {'action':__('Fail'), 'msg':__('Validator.IP')};
    }
    
    return {'action':__('Success'), 'msg':__('OK')};
}

function isValidPercentage(num){
  if(num < 0 && num > 100){
    return {'action':__('Fail'), 'msg':__('Validator.Fail', 'percentage')};
  }
  return {'action':__('Success'), 'msg':__('OK')};
}

exports.isValidPassword = isValidPassword



// WEBPACK FOOTER //
// ./src/validator/index.js